export const en = {
  home: 'home'
}